/**
 * Reducer for managing selected columns state
 * @param {Record<string, boolean>} state - The current state (object with IDs as keys).
 * @param {object} action
 * @param {string} action.type - The type of the action.
 * @param {object} action.payload - The payload of the action.
 * @param {string} [action.payload.id] - The column id.
 * @param {string[]} [action.payload.ids] - The column ids.
 * @returns {Record<string, boolean>} The new state (object with IDs as keys)
 */
function selectedColumnsReducer(state, action) {
  switch (action.type) {
    case 'SELECT_COLUMN': {
      const prevState = { ...state };
      const newState = {
        ...prevState,
        [action.payload.id]: true,
      };
      return newState;
    }
    case 'DESELECT_COLUMN': {
      const prevState = { ...state };
      const { [action.payload.id]: _removed, ...rest } = prevState;
      return rest;
    }
    case 'SELECT_MANY_COLUMNS': {
      const prevState = { ...state };
      const newState = {
        ...prevState,
        ...action.payload.ids.reduce((acc, id) => ({ ...acc, [id]: true }), {}),
      };
      return newState;
    }
    case 'DESELECT_MANY_COLUMNS': {
      const prevState = { ...state };
      const idsToRemove = new Set(action.payload.ids || []);
      const rest = Object.keys(prevState).reduce((/** @type {Record<string, boolean>} */ acc, key) => {
        if (!idsToRemove.has(key)) acc[key] = prevState[key];
        return acc;
      }, {});
      return rest;
    }
    default:
      return state;
  }
}

export default selectedColumnsReducer;
